import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField/TextField';

//Api
import tipoDestino_api from '../../../../api/tipoDestino_api';
import residuo_api from '../../../../api/residuo_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';
import { validarCampos } from '../../../../helpers/ValidadorDeCampos';
export default function IdentificacaoDestino({ destino, setDestino, errors, setErrors, campos }) {

    //Estado das opções do select tipo de destino
    const [optionsTipoDestino, setOptionsTipoDestino] = useState([]);

    //Estado das opçoes do select de tipo de residuo
    const [optionsTiposResiduo, setOptionsTiposResiduos] = useState([]);

    //Carrega os dados dos selects de tipo de destino e tipo de residuo
    useEffect(() => {
        tipoDestino_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { text: value.tbTipoDestino_Descricao, value: value.id.toString() };
            })
            if (!destino.id) {
                setDestino({ ...destino, tbTipoDestino_id: response.data[0].value })
            }
            setOptionsTipoDestino(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null));

        residuo_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { label: value.descricao, value: value.id };
            })
            setOptionsTiposResiduos(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null));
    }, []);

    //Change para o select com multipla escolha
    const onChangeMultiSelect = (e, select) => {
        const _destino = {
            ...destino,
            [select.name]: e
        }
        const erros = validarCampos(_destino, campos.filter(c => c.name == select.name));
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[select.name];
            setErrors(_errors);
        } else {
            const _errors = { ...errors, ...erros[0] };
            setErrors(_errors);
        }
        setDestino(_destino);
    }

    //Change para os outros campos do formulario
    const onChangeDestino = (e) => {

        const { name, value } = e.target;
        const _destino = {
            ...destino,
            [name]: value
        }
        const erros = validarCampos(_destino, campos.filter(c => c.name == name));
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            const _errors = { ...errors, ...erros[0] };
            setErrors(_errors);
        }
        setDestino(_destino);
    }

    //Opções para o select de status
    const optionsStatus = [
        { text: "Ativo", value: "Ativo" },
        { text: "Cancelado", value: "Cancelado" },
        { text: "Suspenso", value: "Suspenso" },
    ]

    return (
        <div>
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"* CNPJ"} invalid={errors.cnpj ? true : false} value={destino.cnpj} onChange={onChangeDestino} name="cnpj" maxLength="18" mask={mascaras.cnpjMask} />
                    {errors.cnpj && <span className={"form-control-label text-danger"}>{errors.cnpj.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength="20" label={"Inscrição"} invalid={errors.inscricao ? true : false} value={destino.inscricao} onChange={onChangeDestino} name="inscricao" />
                    {errors.inscricao && <span className={"form-control-label text-danger"}>{errors.inscricao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength="100" label={"* Responsável"} invalid={errors.responsavel ? true : false} value={destino.responsavel} onChange={onChangeDestino} name="responsavel" />
                    {errors.responsavel && <span className={"form-control-label text-danger"}>{errors.responsavel.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength="150" label={"* E-mail"} type="email" invalid={errors.email ? true : false} value={destino.email} onChange={onChangeDestino} name="email" />
                    {errors.email && <span className={"form-control-label text-danger"}>{errors.email.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength="100" label={"* Fantasia"} invalid={errors.fantasia ? true : false} value={destino.fantasia} onChange={onChangeDestino} name="fantasia" />
                    {errors.fantasia && <span className={"form-control-label text-danger"}>{errors.fantasia.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength="150" label={"* Razão social"} invalid={errors.razao ? true : false} value={destino.razao} onChange={onChangeDestino} name="razao" />
                    {errors.razao && <span className={"form-control-label text-danger"}>{errors.razao.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength="20" label={"* Fone"} invalid={errors.fone ? true : false} value={destino.fone} onChange={onChangeDestino} mask={mascaras.celularMask} name="fone" />
                    {errors.fone && <span className={"form-control-label text-danger"}>{errors.fone.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"* Tipo de destino"} type={"select"} options={optionsTipoDestino} invalid={errors.tbTipoDestino_id ? true : false} value={destino.tbTipoDestino_id} onChange={onChangeDestino} name="tbTipoDestino_id" />
                    {errors.tbTipoDestino_id && <span className={"form-control-label text-danger"}>{errors.tbTipoDestino_id.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField name={"status"} label="* Status" type={"select"} options={optionsStatus} value={destino.status} onChange={onChangeDestino} />
                    {errors.status && <span className={"form-control-label text-danger"}>{errors.status.message}</span>}
                </Col>

            </Row>
            <Row>
                <Col md="12" lg="12">
                    <TextField label={"* Tipos de resíduo"} type={"select"} multiple options={optionsTiposResiduo} invalid={errors.tiposResiduos ? true : false} value={destino.tiposResiduos} onChange={onChangeMultiSelect} name="tiposResiduos" />
                    {errors.tiposResiduos && <span className={"form-control-label text-danger"}>{errors.tiposResiduos.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength="30" label={"Orgão de expedição da licença"} invalid={errors.orgaoExpLicencaOperacao ? true : false} value={destino.orgaoExpLicencaOperacao} onChange={onChangeDestino} name="orgaoExpLicencaOperacao" />
                    {errors.orgaoExpLicencaOperacao && <span className={"form-control-label text-danger"}>{errors.orgaoExpLicencaOperacao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField maxLength={"30"} label={"Número da licença de operação"} invalid={errors.numeroLicencaOperacao ? true : false} value={destino.numeroLicencaOperacao} onChange={onChangeDestino} name="numeroLicencaOperacao" />
                    {errors.numeroLicencaOperacao && <span className={"form-control-label text-danger"}>{errors.numeroLicencaOperacao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Validade da licença"} type={"date"} invalid={errors.validadeLicencaOperacao ? true : false} value={destino.validadeLicencaOperacao} onChange={onChangeDestino} name="validadeLicencaOperacao" />
                    {errors.validadeLicencaOperacao && <span className={"form-control-label text-danger"}>{errors.validadeLicencaOperacao.message}</span>}
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <TextField maxLength={"100"} label={"Protocolo/Averbação"} invalid={errors.protocolo_Averbacao ? true : false} value={destino.protocolo_Averbacao} onChange={onChangeDestino} name="protocolo_Averbacao" />
                    {errors.protocolo_Averbacao && <span className={"form-control-label text-danger"}>{errors.protocolo_Averbacao.message}</span>}
                </Col>
                <Col md="12" lg="4">
                    <TextField label={"Data averbação"} type={"date"} invalid={errors.dataAverbacao ? true : false} value={destino.dataAverbacao} onChange={onChangeDestino} name="dataAverbacao" />
                    {errors.dataAverbacao && <span className={"form-control-label text-danger"}>{errors.dataAverbacao.message}</span>}
                </Col>

            </Row>

        </div >
    )
}